export function jsonTryParse<T = any>(json, cb?: (err: Error) => void, reviver?: (key, value) => any) {
	try {
		return JSON.parse(json, reviver) as T;
	} catch (e) {
		cb && cb(e);
	}
}

export function jsonTryStringify(
	value,
	cb?: (err: Error) => void,
	replacer?: (key, value) => any,
	space?: string | number
) {
	try {
		let cache = new Set();
		replacer =
			replacer ||
			((_, val) => {
				if (typeof val === 'object' && val !== null) {
					// Duplicate reference found, discard key
					if (cache.has(val)) {
						return;
					}
					// Store value in our collection
					cache.add(val);
				}
				return val;
			});
		const result = JSON.stringify(value, replacer, space);
		cache.clear();
		cache = null;
		return result;
	} catch (e) {
		cb && cb(e);
	}
}
